export default __webpack_public_path__ + "static/media/ssk.009816f4.JPG";